/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                from 'react';
import { StyledIconInline } from '../StyledIconInline';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const StyledIconCloudDownload = StyledIconInline.extend`
  height: ${props => props.height || '20px'};
  width: ${props => props.width || '24px'};
`;

export const IconCloudDownload = (props) => (
    <StyledIconCloudDownload {...props}>
        <svg viewBox="0 0 24 20" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlnsXlink="http://www.w3.org/1999/xlink">
            <g strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <path d="M11.5308,19.4985 L11.5308,8.5265"/>
                <polyline points="14.4766 16.4463 11.5306 19.4983 8.5846 16.4463"/>
                <path d="M15.0337,13.5171 L18.5777,13.5171 C21.0517,13.5171 23.1427,11.5901 23.1427,9.3101 C23.1427,
                6.9571 20.8807,4.8551 18.0567,5.1281 C17.4527,3.1751 15.5507,1.6671 12.8417,2.0011 C9.2217,
                -1.0279 3.8047,1.0231 3.0177,5.7761 C-1.0623,8.2771 1.0687,13.5171 5.1687,13.5171 L7.9797,13.5171"/>
            </g>
        </svg>
    </StyledIconCloudDownload>
);



// WEBPACK FOOTER //
// ./src/components/atoms/IconCloudDownload/index.js